export default __webpack_public_path__ + "static/media/ecoin.963b05e3.svg";